module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "copyright-information"
    }
  }, [_c('div', {
    staticStyle: {
      "padding-top": "180px"
    }
  }, [_c('p', [_vm._v("But now the sounds of population fail,")]), _vm._v(" "), _c('p', [_vm._v("No cheerful murmurs fluctuate in the gale,")]), _vm._v(" "), _c('p', [_vm._v("No busy steps the grass-grown footway tread,")]), _vm._v(" "), _c('p', [_vm._v("But all the blooming flush of life is fled.")]), _c('br'), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_vm._v("Oliver Goldsmith")])]), _vm._v(" (The Deserted Village)")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("They say there’s tanks and armoured cars,")]), _vm._v(" "), _c('p', [_vm._v("And guns that fire like hell,")]), _vm._v(" "), _c('p', [_vm._v("I wonder if the skylark sings")]), _vm._v(" "), _c('p', [_vm._v("On the plain I knew so well?")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "12em"
    }
  }, [_vm._v("(Salisbury Plain)")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "15em"
    }
  }, [_vm._v("C.H.C.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 75
// module chunks = 0